function Info() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      viewBox="0 0 24 24"
    >
      <g>
        <g
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="10" data-name="--Circle"></circle>
          <path d="M12 12L12 16"></path>
          <path d="M12 8L12 8"></path>
        </g>
      </g>
    </svg>
  );
}

export default Info;
